import React, { useEffect, useState } from 'react';
import { Container, Card, Row, Col, Badge } from 'react-bootstrap';

export default function SellerBidStatus() {
  const [bids, setBids] = useState([]);
  const seller = JSON.parse(sessionStorage.getItem('user'));
  const sellerId = seller?.id;

  useEffect(() => {
    const fetchSellerBids = async () => {
      try {
        const res = await fetch('https://vyaparapi.emedha.in/api/seller/bid-status', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ seller_id: sellerId })
        });

        const data = await res.json();
        setBids(data);
      } catch (err) {
        console.error('❌ Error fetching seller bid status:', err);
      }
    };

    if (sellerId) fetchSellerBids();
  }, [sellerId]);

  return (
    <Container className="my-4">
      <h3 className="text-center mb-4">📊 My Seller Bids</h3>

      {bids.length === 0 ? (
        <p className="text-center text-muted">No bids found.</p>
      ) : (
        bids.map((bid, i) => (
          <Card key={i} className="mb-4 shadow-sm">
            <Card.Body>
              <h5 className="mb-2">🆔 Bid ID: {bid.bid_id}</h5>
              <Row>
                <Col md={6}><strong>Category:</strong> {bid.category} / {bid.sub_category}</Col>
                <Col md={6}><strong>Price Range:</strong> ₹{bid.price_from} - ₹{bid.price_to}</Col>
              </Row>
              <Row>
                <Col md={6}><strong>Warranty:</strong> {bid.warranty}</Col>
                <Col md={6}><strong>Specs:</strong> {bid.selected_specs}</Col>
              </Row>
              <Row className="mt-2">
                <Col md={6}><strong>My Offer:</strong> ₹{bid.seller_offer}</Col>
                <Col md={6}>
                  <strong>Status:</strong>{' '}
                  <Badge bg={
                    bid.status === 'accepted' ? 'success' :
                    bid.status === 'rejected' ? 'danger' : 'secondary'
                  }>
                    {bid.status.toUpperCase()}
                  </Badge>
                </Col>
              </Row>
              {bid.status === 'accepted' && (
                <>
                  <p className="mt-2"><strong>Accepted At:</strong> {new Date(bid.accepted_at).toLocaleString()}</p>
                  <p><strong>Paid Amount (10%):</strong> ₹{bid.paid_amount_10per}</p>
                </>
              )}
              <p className="text-muted small mt-3">🕒 Bid Created At: {new Date(bid.bid_created_at).toLocaleString()}</p>
            </Card.Body>
          </Card>
        ))
      )}
    </Container>
  );
}
